import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../pages/css/LeadDatabase.css";
import banner from '../images/Hrias-b2b-banner.png';
import verified90 from '../images/hrias-multi-b2c-2.png';
import filtersb2b from '../images/Hrias-multi-3.png'
import intentSignal from '../images/Hrias-multi-4.png';
import intentSignal2 from '../images/Hrias-Intent_Signal.png';
import outreach from '../images/Hrias-multi-5.png'
import b2bcrm from '../images/hrias-multi-b2c-3.png';
import customDev from '../images/Hrias-Custom_Development.png';
import cTOne from '../images/kpmg.png';
import cTTwo from '../images/deloite.png';
import cTThree from '../images/berkshire.png';
import cTFive from '../images/pwc.jpg';
import cTSix from '../images/microsoft.png';
import cTFour from '../images/Google.png';
import dashImg from '../images/hrias-multi-b2c-1.png';
import { useNavigate } from "react-router-dom";

function MultiChannelSequenceb2c() {
    const navigate = useNavigate();
    return (
        <div className="b2b-lead-page">
            {/* Hero Section */}
            <section
                className="hero-section text-center text-white d-flex align-items-center justify-content-center"
                style={{
                    backgroundImage:
                        `url(${banner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    width: "100%",
                    height: "40vh",
                }}
            >
                <div className="container" style={{ color: "#ffffff" }}>
                    <h1 className="fw-bold" style={{ color: "#275a8eff" }}>
                        Facebook, Instagram, or WhatsApp?
                        <span className="highlight" style={{ color: "#7102c1ff" }}>
                            Reach your customers wherever
                        </span> they are — from one dashboard.
                    </h1>

                    <p className="lead mt-3" style={{ color: "#890059ff" }}>
                        Every customer’s journey is unique. With Hrias, connect across popular social platforms and engage effortlessly through one unified system.
                    </p>

                    <button
                        className="btn btn-primary mt-4"
                        style={{
                            backgroundColor: "#134373ff",
                            border: "none",
                            color: "#ffffffff",
                            fontWeight: "600",
                            borderRadius: "30px",
                            padding: "12px 30px",
                            transition: "all 0.3s ease",
                        }}
                        onMouseOver={(e) => (e.target.style.backgroundColor = "#5197dcff")}
                        onMouseOut={(e) => (e.target.style.backgroundColor = "#134373ff")}
                        onClick={() => navigate("/contact-us-hrias")}
                    >
                        Contact Sales
                    </button>
                </div>

            </section>
            <section>
                <div className="container py-5">
                    <img
                        src={dashImg}
                        alt="Padded Container"
                        className="img-fluid rounded shadow-lg" style={{ width: '100%', height: '960px' }}
                    />
                </div>
            </section>
            <section className="container my-5 partner-section">
                {/* Heading */}
                <h5 className="text-center partner-heading">
                    Trusted by <span style={{ color: '#fd7e14' }}>6000+</span> Industry Leaders
                </h5>

                {/* Logo Row */}
                <div className="d-flex justify-content-center align-items-center flex-wrap gap-4 mt-4">
                    <img src={cTOne} alt="KPMG" className="partner-logo" style={{ width: '120px', height: 'auto' }} />
                    <img src={cTTwo} alt="Deloitte" className="partner-logo" style={{ width: '130px', height: 'auto' }} />
                    <img src={cTThree} alt="Berkshire" className="partner-logo" />
                    <img src={cTFour} alt="Google" className="partner-logo" />
                    <img src={cTFive} alt="PwC" className="partner-logo" />
                    <img src={cTSix} alt="Microsoft" className="partner-logo" />
                </div>
            </section>


            {/* Section 1 — Verified B2B Contacts */}
            <section className="feature-section py-5 bg-light">
                <div className="container d-flex flex-column flex-md-row align-items-center">
                    <div className="col-md-6 mb-4 mb-md-0 text-md-start">
                        <h3 className="feature-title">
                            Launch Multichannel Sequences Across Facebook, Instagram & WhatsApp
                        </h3>
                        <p className="feature-text">
                            HRIAS helps you automate personalized outreach across the apps your customers use every day — connect on Facebook, engage on Instagram, and follow up instantly through WhatsApp or call. All from one simple, unified dashboard.
                        </p>

                        <button className="btn btn-outline-primary" onClick={() => navigate("/contact-us-hrias")}>Explore Leads</button>
                    </div>
                    <div className="col-md-6 text-center">
                        <img
                            src={verified90}
                            alt="Verified Leads"
                            className="img-fluid rounded shadow-sm"
                        />
                    </div>
                </div>
            </section>

            {/* Section 2 — Smart Filters & Advanced Search */}
            <section className="feature-section py-5">
                <div className="container d-flex flex-column flex-md-row-reverse align-items-center">
                    <div className="col-md-6 mb-4 mb-md-0 text-md-start" style={{ marginLeft: '20px' }}>
                        <h3 className="feature-title">
                            Social DMs not enough? Automatically connect on Facebook, Instagram & WhatsApp
                        </h3>
                        <p className="feature-text">
                            Reach your audience across all major social platforms — send Instagram DMs, Facebook messages, story interactions, and WhatsApp follow-ups in one sequence.
                            Use the HRIAS Chrome Extension to find users, enrich details, and import them directly into your campaigns within seconds!
                        </p>

                        <button className="btn btn-outline-primary" onClick={() => navigate("/contact-us-hrias")}>See Filters</button>
                    </div>
                    <div className="col-md-6 text-center" >
                        <img
                            src={filtersb2b}
                            alt="Smart Filters"
                            className="img-fluid rounded shadow-sm"
                        />
                    </div>
                </div>
            </section>

            {/* Section 3 — Real-Time Intent Signals */}
            <section className="feature-section py-5 bg-light">
                <div className="container d-flex flex-column flex-md-row align-items-center">
                    <div className="col-md-6 mb-4 mb-md-0 text-md-start">
                        <h3 className="feature-title">
                            Boost Your Conversions — Contact Interested Customers Instantly with HRIAS
                        </h3>
                        <p className="feature-text">
                            Get verified phone numbers, connect through WhatsApp or direct calls, and reach customers who have already shown interest.
                            Receive call reminders, make calls from HRIAS or connected apps, and keep all conversations tracked, summarized, and organized automatically.
                        </p>

                        <button className="btn btn-outline-primary" onClick={() => navigate("/contact-us-hrias")}>View Insights</button>
                    </div>
                    <div className="col-md-6 text-center">
                        <img
                            src={intentSignal}
                            alt="Intent Signals"
                            className="img-fluid rounded shadow-sm"
                        />
                    </div>
                </div>
            </section>

            {/* Section 4 — Automated Multi-Channel Outreach */}
            <section className="feature-section py-5">
                <div className="container d-flex flex-column flex-md-row-reverse align-items-center">
                    <div className="col-md-6 mb-4 mb-md-0 text-md-start" style={{ marginLeft: '20px' }}>
                        <h3 className="feature-title">
                            Turn Silent Visitors into Customers with WhatsApp Follow-Ups
                        </h3>
                        <p className="feature-text">
                            Add automated WhatsApp follow-ups to remind, reconnect, or re-engage customers easily.
                            Send personalized messages at scale with built-in safety tools to protect your number and deliver high-quality engagement.
                        </p>

                        <button className="btn btn-outline-primary" onClick={() => navigate("/contact-us-hrias")}>Automate Now</button>
                    </div>
                    <div className="col-md-6 text-center">
                        <img
                            src={outreach}
                            alt="Outreach Automation"
                            className="img-fluid rounded shadow-sm"
                        />
                    </div>
                </div>
            </section>

            {/* Section 5 — CRM & Integrations */}
            <section className="feature-section py-5 bg-light">
                <div className="container d-flex flex-column flex-md-row align-items-center">
                    <div className="col-md-6 mb-4 mb-md-0 text-md-start">
                        <h3 className="feature-title">
                            Boost Conversions with Smart Personal Touch Actions
                        </h3>
                        <p className="feature-text">
                            Some interactions work best personally — like replying to an Instagram comment or sending a heartfelt message.
                            HRIAS lets you schedule, track, and manage these manual actions so your communication feels real, warm, and human at every step.
                        </p>

                        <button className="btn btn-outline-primary" onClick={() => navigate("/contact-us-hrias")}>View Dashboard</button>
                    </div>
                    <div className="col-md-6 text-center">
                        <img
                            src={b2bcrm}
                            alt="CRM Integration"
                            className="img-fluid rounded shadow-sm"
                        />
                    </div>
                </div>
            </section>

            <div className="info-box d-flex flex-column flex-md-row align-items-center mb-5">
                <div className="info-img col-md-6 p-3">
                    <img
                        src={intentSignal2}
                        alt="Intent Signals"
                        className="img-fluid rounded bg-white p-3 shadow-sm"
                    />
                </div>

                <div className="info-content col-md-6 p-4 text-md-start">
                    <h4 className="fw-bold mb-3">Powered by HRIAS Intent Signals</h4>

                    <p className="text-muted fw-semibold mb-3" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
                        HRIAS helps you identify real consumer interest by tracking signals such as profile visits, message responses, post engagement, and more.
                        Get real-time alerts when potential customers interact with your content or show buying intent.
                    </p>

                    <p className="text-muted fw-semibold mb-4" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.7' }}>
                        Access detailed user insights including activity, interests, location, preferred platform, and communication behavior — all from one
                        dashboard. HRIAS ensures you always know who’s most likely to buy and when to reach out through Facebook, Instagram, WhatsApp, or call.
                    </p>

                    <button className="btn btn-primary px-4 py-2" onClick={() => navigate("/contact-us-hrias")} >Contact Sales</button>
                </div>
            </div>

            {/* Section 6 — Custom Development & Add-ons */}
            <section className="feature-section py-5">
                <div className="container d-flex flex-column flex-md-row-reverse align-items-center">
                    <div className="col-md-6 mb-4 mb-md-0 text-md-start" style={{ marginLeft: '20px' }}>
                        <h3 className="feature-title">Custom Development for Your Needs</h3>
                        <p className="feature-text">
                            Need extra functionality? HRIAS can develop custom modules like
                            AI-enhanced filters, call tracking dashboards, or lead scoring
                            algorithms tailored to your business.
                        </p>
                        <button className="btn btn-outline-primary" onClick={() => navigate("/contact-us-hrias")}>Request Customization</button>
                    </div>
                    <div className="col-md-6 text-center">
                        <img
                            src={customDev}
                            alt="Custom Development"
                            className="img-fluid rounded shadow-sm"
                        />
                    </div>
                </div>
            </section>

            <section className="container my-5 client-review-section">
                <div className="row align-items-center">
                    {/* Left side - client image */}
                    <div className="col-12 col-md-3 text-center">
                        <img
                            src="https://img.freepik.com/free-photo/business-concept-portrait-confident-young-businesswoman-keeping-arms-crossed-looking-camera-w_1258-104422.jpg?semt=ais_hybrid&w=740&q=80" // replace with your client's photo
                            alt="Client"
                            className="client-img"
                        />
                    </div>

                    {/* Right side - review text */}
                    <div className="col-12 col-md-9">
                        <p className="client-review">
                            “HRIAS Multichannel Sequences has completely reshaped the way we engage with our B2C customers across WhatsApp, Facebook, Instagram, and even direct calls.
                            The personalized automation feels natural and incredibly responsive, allowing us to connect with customers faster and more meaningfully.
                            Our engagement flow is smoother than ever, and we’ve seen a significant boost in conversions and customer interaction!”
                        </p>

                        <h3 className="client-name">Sophie Mitchell</h3>
                        <p className="client-position">Customer Engagement Manager, BrightWave Retail</p>


                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section text-center py-5">
                <div className="container">
                    <h2 className="cta-title fw-bold mb-3 text-white">
                        Start Building Your Multichannel Sequence With Confidence
                    </h2>
                    <p className="cta-subtitle mt-3 mb-4">
                        Get verified leads, real-time insights, and AI-powered automation
                        with HRIAS — the smarter way to grow your sales.
                    </p>
                    <button className="btn btn-primary px-4 py-2" onClick={() => navigate("/contact-us-hrias")}>Contact Sales</button>
                </div>
            </section>
        </div>
    );
}

export default MultiChannelSequenceb2c;
